import React from "react";
import { iconProps } from "../../../../Helper";

export const ImageToImageIcon = ({ className }: iconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <mask
        id="mask0_15322_30738"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="17"
        height="16"
      >
        <rect
          x="0.5"
          width="16"
          height="16"
          fill="#D9D9D9"
          className={className}
        />
      </mask>
      <g mask="url(#mask0_15322_30738)">
        <path
          d="M7.50016 15.0755V13.6654H4.03866C3.70188 13.6654 3.41683 13.5487 3.1835 13.3154C2.95016 13.082 2.8335 12.797 2.8335 12.4602V3.53721C2.8335 3.20043 2.95016 2.91537 3.1835 2.68204C3.41683 2.44871 3.70188 2.33204 4.03866 2.33204H7.50016V0.921875H8.50016V15.0755H7.50016ZM3.8335 11.9987H7.50016V7.60121L3.8335 11.9987ZM9.8335 13.6654V7.99871L13.1668 11.9987V3.53721C13.1668 3.48587 13.1454 3.43887 13.1027 3.39621C13.06 3.35343 13.013 3.33204 12.9617 3.33204H9.8335V2.33204H12.9617C13.2984 2.33204 13.5835 2.44871 13.8168 2.68204C14.0502 2.91537 14.1668 3.20043 14.1668 3.53721V12.4602C14.1668 12.797 14.0502 13.082 13.8168 13.3154C13.5835 13.5487 13.2984 13.6654 12.9617 13.6654H9.8335Z"
          fill="#EFF5F6"
          className={className}
        />
      </g>
    </svg>
  );
};
